import { getFirstName } from '@rental-manager/models/PropertyInfo';
import { LandlordProfileModel } from './Types';

const LandlordModel = (landlord: LandlordProfileModel) => {
  const { name = '', email = '' } = landlord || {};

  return {
    firstName: getFirstName(name),
    name,
    email,
  };
};

export default LandlordModel;
